import React from "react";
import Grid from "@material-ui/core/Grid";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from "@material-ui/core";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import UploadFileStance from "../../../components/uploadFile/uploadFileStance";

import {
    numberWithCommaDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const OrderAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Operación \ Posturas Administrativas"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getAdminOrders}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestamista" isBold={true}/>
                                    <Dropdown
                                        name="catInstitutionLenderFilter"
                                        filter={true}
                                        filterBy="nombreCorto"
                                        options={props.catInstitutionCatalog}
                                        optionLabel="nombreCorto"
                                        placeholder="Seleccione..."
                                        onChange={props.saveFilters}
                                        value={props.catInstitutionLenderFilter}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestatario" isBold={true}/>
                                    <Dropdown
                                        name="catInstitutionBorrowerFilter"
                                        filter={true}
                                        filterBy="nombreCorto"
                                        options={props.catInstitutionCatalog}
                                        optionLabel="nombreCorto"
                                        placeholder="Seleccione..."
                                        onChange={props.saveFilters}
                                        value={props.catInstitutionBorrowerFilter}/>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fiduciario" isBold={true}/>
                                    <Typography variant="subtitle2" gutterBottom className={"secondary-text"}>
                                        <Checkbox name="isAdmin"
                                                  checked={props.isAdmin}
                                                  onChange={props.saveCheckFilters}/>
                                        &nbsp; Administrativas
                                    </Typography>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <br/>
                                    <Button
                                        style={{'float': 'right'}}
                                        label="Limpiar"
                                        className="p-button-secondary"
                                        onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <UploadFileStance type={["text/csv"]}
                                               size="1000000"
                                               urlAction="/stance/lender/order/upload"
                                               className="p-button-secondary"
                                               titleHeader="Cargar archivo"
                                               titleButton="Importar"
                                               errorTypeMessage="El documento debe ser en formato .csv"
                                               errorSizeMessage="El tamaño no debe ser mayor a 1MB"
                                               instructions="Debe ser un archivo en formato CSV."
                                               action={props.searchAll}/>&nbsp;
                            <Button type="button" iconPos="left" label="Insertar postura / hecho"
                                    className="p-button-secondary"
                                    onClick={props.insertOrderTradeAdminScreen}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.orderAdminList}
                            selectionMode="single"
                            responsive={true}
                            onSelectionChange={props.handleSelectOrderAdmin}
                            selection={props.selectedOrderAdmin}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="nomCortoPtm" header="Prestamista" style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="nomCortoPtt" header="Prestatario" style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="statusPv" header="Estatus" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="emision" header="Emisora" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="cantidad" header="Títulos" style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="tasa" header="Tasa" style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                            <Column field="sobreTasa" header="Sobretasa" style={{textAlign: 'right'}}
                                    body={rateMultipliedByOneHundredDataTableTemplate} sortable={true}/>
                            <Column field="plazo" header="Plazo" style={{textAlign: 'right'}}
                                    body={numberWithCommaDataTableTemplate} sortable={true}/>
                            <Column field="aforo" header="Aforo" style={{textAlign: 'left'}} sortable={true}/>
                            <Column header="Acciones"
                                    body={props.orderAdminTemplate}
                                    style={{textAlign: 'center', width: '8em'}}/>
                        </DataTable>
                        {props.confirmationMsg}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default OrderAdmin;


OrderAdmin.propTypes = {
    searchAll: PropTypes.element.isRequired
}